var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38.9744,
    rx: 8.20513,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6827 9.23076H28.6869L22.1254 17.5294L29.8462 28.8205H23.8037L19.0682 21.9721L13.6508 28.8205H10.6428L17.6627 19.9477L10.2564 9.23076H16.4542L20.7313 15.4882L25.6827 9.23076ZM24.6296 26.8297H26.2927L15.5488 11.1168H13.7645L24.6296 26.8297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/X Logo.81a2e121e132ab1d752acfcd3e92e457.svg";
export { ForwardRef as ReactComponent };